<!--
 * @Description:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-03-29 13:49:26
 -->
<template>
  <div class="header-box">
    <div class="logo">
      <!-- <img
        src="http://cdn.yxvzb.com/WEB/sass/img/logo1.png"
        style="width:2.4em;height:2.4em;"
      /> -->
      <h1>维元数服管理平台</h1>
    </div>
    <!-- <el-menu background-color="#fff" text-color="#fff" active-text-color="$--color-primary;" :default-active="tabActive" class="el-menu-demo" mode="horizontal" @select="handleSelect">
    <el-menu-item v-for="item in tabList" :index="item">{{item}}</el-menu-item>


    </el-menu>-->
    <!-- <ul class="header-tab-ul">
    <li v-for="(item,index) in tabList" :class="['header-tab-li',tabActive == item?'header-tab-li-active':'']" :key="item" @click="handleSelect(item,index)">
      {{item}}
    </li>
    </ul>-->
    <div class="right">
      <ct-user class="hand"></ct-user>
      <!-- <el-badge :value="12" class="item " style="margin-left:20px">
      <i class="el-icon-bell" style="font-size:25px"></i>
      </el-badge>-->
    </div>
  </div>
</template>
<script>
import ctUser from '@/components/Common/user.vue';

export default {
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1'
    };
  },
  components: {
    ctUser
  }
};
</script>
<style lang="scss" scoped>
@import '~@/styles/theme.scss';

// @media screen and (max-width: 1200px) {
//   .header-box {
//     height: 84px !important;
//     //background: #000 !important;
//   }
// }

// @media screen and (min-width: 1200px) {
//   .header-box {
//     height: 5.78vw !important;
//   }
// }
@media screen and (max-width: 1200px) {
  .header-box {
    height: 50px;
  }
}
@media screen and (min-width: 1200px) {
  .header-box {
    height: 60px;
  }
}
.header-box {
  display: flex;
  transition: all 0.5s;
  align-items: center;
  background: $--color-primary;
  position: relative;
  //height: 75px;
  // min-height: 56px;
  // max-height: 90px;

  .right {
    position: absolute;
    right: 50px;
    display: flex;
    align-items: center;
    color: #fff;
  }
  .logo {
    padding: 0 1.5%;
    display: flex;
    align-items: center;
    color: #fff;
    img {
      width: 130px;
    }
    h1 {
      font-size: 1.625em;
      padding-left: 15px;
      width: 400px;
      text-align: left;
    }
  }
  .header-tab-ul {
    display: flex;
    padding-left: 50px;
    .header-tab-li {
      padding: 5px 15px;
      border-radius: 4px;
      font-size: 16px;
      color: #fff;
      background: transtarent;
      text-align: center;
      margin-right: 5px;
      cursor: pointer;
    }
    .header-tab-li-active {
      color: $--color-primary;
      background: #ffffff;
    }
  }
}
</style>
